import {ReactElement, useEffect, useState} from "react";
import {useNavigate, useParams} from "react-router-dom";

import {fetchMagasin} from "@/api/magasin";
import {
  FetchOperationCommerciale,
  FetchOperationCommercialeCommande,
} from "@/api/operationCommerciale";
import iconBack from "@/assets/massification/iconPrevious.svg";
import Button from "@/components/Button/Button";
import Dropdown from "@/components/Dropdown/Dropdown";
import Loader from "@/components/Loader/loader";
import {RecapCommande} from "@/components/OperationCommerciale/RecapCommande/RecapCommande";
import Section from "@/components/Section/Section";
import Title from "@/components/Section/Title";
import {formatDate} from "@/function/formatDate";
import {Magasin} from "@/ts/interface/magasin";
import {
  CommandeAPI,
  OperationCommerciale,
} from "@/ts/interface/operationCommerciale";

function MesCommandesOperationCommerciale(): ReactElement {
  const {id = ""} = useParams();
  const navigate = useNavigate();
  const [commandes, setCommandes] = useState<CommandeAPI[] | null>(null);
  const [isLoad, setIsLoad] = useState<boolean>(true);
  const [magasins, setMagasins] = useState<Magasin[]>([]);
  const [operationCommerciale, setOperationCommerciale] =
    useState<OperationCommerciale | null>(null);

  const [openDescription, setOpenDescription] = useState<boolean>(false);
  useEffect(() => {
    const getMagasins = async (): Promise<void> => {
      const allMagasins = await fetchMagasin();
      setMagasins(allMagasins ? allMagasins : []);
    };
    getMagasins();
    const getCommandes = async (): Promise<void> => {
      const reponse = await FetchOperationCommercialeCommande([
        `operation=${id}`,
      ]);
      if (reponse?.commandes) {
        setCommandes(reponse?.commandes);
        setIsLoad(false);
      }
    };
    getCommandes();
    const getOperationCommerciale = async (): Promise<void> => {
      const reponse = await FetchOperationCommerciale(id);
      if (reponse) {
        setOperationCommerciale(reponse);
      }
    };
    getOperationCommerciale();
  }, []);

  const commandeValidee = commandes?.filter(
    commande => commande.statut === "Validée",
  );

  const CommandeComponents = commandeValidee?.map(
    (commande: CommandeAPI, index: number) => {
      return (
        <Dropdown
          key={commande.commande_id}
          titre={`Commande N°${commande.num_commande}`}
          complementTitre={
            <span>
              {commande?.date_commande
                ? `En date du  ${formatDate(commande?.date_commande)}`
                : ""}
            </span>
          }
          defaultOpen={index === 0}>
          {commande ? (
            <RecapCommande
              commande={commande}
              magasins={magasins}
              fullDetail={true}
            />
          ) : (
            <Loader />
          )}
        </Dropdown>
      );
    },
  );
  return (
    <Section id="CommandeOperationCommerciale">
      <Button
        label="Retour"
        variant="secondary"
        icon={iconBack}
        className="returnButton"
        onClick={() => navigate(-1)}
      />
      <Title title={`Commande de l'opération ${operationCommerciale?.nom}`} />
      <Button
        label={
          openDescription
            ? "Masquer la description de l'opération"
            : "Voir la description de l'opération"
        }
        variant="secondary"
        onClick={() => setOpenDescription(prev => !prev)}
      />

      {openDescription && (
        <div
          className="operationCommerciale-header--description description-text"
          style={{maxWidth: "90%", margin: "10px auto"}}
          dangerouslySetInnerHTML={{
            __html: operationCommerciale?.description ?? "",
          }}></div>
      )}
      {isLoad ? <Loader /> : CommandeComponents}
    </Section>
  );
}

export default MesCommandesOperationCommerciale;
